import React from 'react';
import PropTypes from 'prop-types';

import { st, classes } from './Timeline.st.css';
import { dataHooks } from './Timeline.constants';
import TimelineItem from './TimelineItem';
import { TimelineProps } from './Timeline.types';

function Timeline({ dataHook, items, className, gap, skin }: TimelineProps) {
  return (
    <ol
      className={st(classes.root, className)}
      data-hook={dataHook}
      data-skin={skin}
    >
      {items.map((item, idx) => (
        <TimelineItem
          key={idx}
          item={item}
          idx={idx}
          dataHook={`${dataHooks.timelineListEvent}-${idx}`}
          gap={gap}
          skin={skin}
        />
      ))}
    </ol>
  );
}

Timeline.displayName = 'Timeline';

Timeline.propTypes = {
  dataHook: PropTypes.string,
  className: PropTypes.string,
  gap: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      labelAction: PropTypes.node,
      customPrefix: PropTypes.node,
      suffix: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      line: PropTypes.oneOf(['filled', 'dashed']),
    }),
  ).isRequired,
  skin: PropTypes.oneOf(['dark', 'standard', 'neutral']),
};

export default Timeline;
